import React from "react";
import { ChevronUp, ChevronDown, ChevronsUpDown } from "lucide-react";

const SortableHeader = ({
  children,
  sortKey,
  sortConfig,
  onSort,
  align = "left",
  sortable = true,
}) => {
  const getSortIcon = () => {
    if (!sortable || sortConfig?.key !== sortKey) {
      return <ChevronsUpDown size={16} opacity={0.5} />;
    }
    return sortConfig.direction === "ascending" ? (
      <ChevronUp size={16} />
    ) : (
      <ChevronDown size={16} />
    );
  };

  const handleClick = () => {
    if (sortable) onSort(sortKey);
  };

  const style = align === "center" ? styles.thCenter : styles.thLeft;
  const className = sortable ? "sortable-header" : "";

  return (
    <th style={style} onClick={handleClick} className={className}>
      <div
        style={align === "center" ? styles.centerContent : styles.headerContent}
      >
        <div style={styles.headerText}>
          {children}
          {sortable && getSortIcon()}
        </div>
      </div>
    </th>
  );
};

const styles = {
  thLeft: {
    textAlign: "left",
    padding: "8px 12px",
    borderBottom: "1px solid #333",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    userSelect: "none",
  },
  thCenter: {
    textAlign: "center",
    padding: "12px 8px",
    borderBottom: "1px solid #333",
    fontSize: "14px",
    fontWeight: "600",
  },
  headerContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
  },
  centerContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  headerText: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
};

export default SortableHeader;
